import { render, staticRenderFns } from "./moduleIndex.vue?vue&type=template&id=7658c714&scoped=true"
import script from "./moduleIndex.vue?vue&type=script&lang=js"
export * from "./moduleIndex.vue?vue&type=script&lang=js"
import style0 from "./moduleIndex.vue?vue&type=style&index=0&id=7658c714&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7658c714",
  null
  
)

export default component.exports